import React from 'react';

const services = [
  {
    icon: 'ri-customer-service-line',
    title: 'Atención 7×24',
    description: 'Servicio al cliente las 24 horas del día, los 7 días de la semana, en todo el mundo.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Línea de Servicio Posventa',
    description: 'Soporte técnico disponible 24 horas para resolver cualquier consulta sobre el producto.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Entrega Garantizada',
    description: 'Suministro oportuno de productos de alta calidad para asegurar la satisfacción del usuario.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Control Estricto de Calidad',
    description: 'Procesos de control de calidad rigurosos en cada etapa de producción y embarque.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Soporte Técnico Profesional',
    description: 'Equipo técnico especializado que acompaña al cliente en la implementación del producto.',
  },
  {
    icon: 'ri-test-tube-line',
    title: 'Pruebas Técnicas Gratuitas',
    description: 'Análisis y pruebas físico-químicas del producto sin costo adicional para el cliente.',
  },
];

export default function RixinService() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 md:mb-18">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-customer-service-line text-sm w-4 h-4 flex items-center justify-center" />
              Sistema de Servicio
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Servicio al Cliente <span className="text-accent-500">de Clase Mundial</span>
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
              Rixin Group no solo fabrica productos de calidad, sino que también ofrece un sistema
              de servicio integral que respalda a sus distribuidores y clientes finales en cada paso.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {services.map((svc) => (
              <div
                key={svc.title}
                className="bg-background-50 rounded-lg p-6 border border-background-200/60 hover:border-accent-300/60 transition-all duration-300 group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${svc.icon} text-xl`} />
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">{svc.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{svc.description}</p>
              </div>
            ))}
          </div>

          {/* Service philosophy */}
          <div className="mt-14 md:mt-18 bg-background-50 rounded-lg p-8 md:p-10 border border-background-200/60">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-heart-3-line text-2xl" />
              </div>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">Filosofía de Servicio</h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed text-left sm:text-justify">
                  <em className="text-primary-600">"Tratarnos con honestidad mutua y superar las necesidades de los clientes. Servicio de todo corazón,
                  para proporcionar a los clientes más valor, suministrar productos de manera oportuna, asegurar la satisfacción del usuario.
                  No solo proporcionamos productos calificados, sino también servicio de alta calidad."</em>
                </p>
                <p className="text-foreground-500 text-xs mt-3">— Rixin Group, Shaanxi, China</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}